export default {
  'emailTemplates.title': 'Manage Email Formats',
  'emailTemplates.dowloadBaseTemplate': 'Download base template',
  'emailTemplates.mailFormat': 'Email Format',
  'emailTemplates.subject': 'Subject',
  'emailTemplates.fromName': 'From Name',
  'emailTemplates.replyToName': 'Reply To (Name)',
  'emailTemplates.fileTypeClassification.html': 'HTML',
  'emailTemplates.fileTypeClassification.text': 'Text',
  'emailTemplates.replyToEmail': 'Reply To (Email)',
  'emailTemplates.fileName': 'File name',
  'emailTemplates.fileType': 'File type',
  'emailTemplates.size': 'Size',
  'emailTemplates.contentType': 'Content type',
  'emailTemplates.eTag': 'ETag',

  // Template types (key emailTemplates.type.*)
  'emailTemplates.type.accountConfirmation': 'Email Account Confirmation',
  'emailTemplates.type.accountResetPassword': 'Password Reset Email',
  'emailTemplates.type.accountWelcomeMessage': 'Welcome Email for New Users',
  'emailTemplates.type.actionSendEmail': 'Action Format - Send Email',
  'emailTemplates.type.requestApproved': 'Request Approved',
  'emailTemplates.type.requestReassigned': 'Request Reassigned',
  'emailTemplates.type.requestAttachments': 'Attached Documents',
  'emailTemplates.type.requestCanceled': 'Request Cancelled',
  'emailTemplates.type.executionSteps': 'Execution Steps',
  'emailTemplates.type.requestPendingApproval': 'Approval Pending',
  'emailTemplates.type.requestPendingCompleteInformation': 'Complete Pending Information',
  'emailTemplates.type.requestPendingSignature': 'Pending Signature',
  'emailTemplates.type.requestPendingTaskCompletion': 'Task Completion Pending',
  'emailTemplates.type.requestRejected': 'Request Denied',
  'emailTemplates.type.requestScheduledExecution': 'Task Completion Pending',
  'emailTemplates.type.accountTwoFactorValidationCode': 'Two-Factor Authentication Code Email',
  'emailTemplates.type.requestVoided': 'Request Canceled',
  'emailTemplates.type.approvalSecurityCode': 'Approval - Security Code',
  'emailTemplates.type.requestWithErrors': 'Request with Errors',
  'emailTemplates.type.internalTaskError': 'Internal Task / Error',
  'emailTemplates.type.accountSecurityAlertNewLogin': 'Security Alert / New Login',
  'emailTemplates.type.requestNewComment': 'Request / New Comment',
  'emailTemplates.type.formFieldApiWithErrors': 'Form API Field / With Errors',
  'emailTemplates.type.taskAssigned': 'Assigned Task',
  'emailTemplates.type.accountWelcomeMessageWithoutInstructions': 'Welcome Email for New Users',
};
